import React from 'react';
import { Table, Form, Button } from 'react-bootstrap';
import { FaTrash, FaPlus } from 'react-icons/fa';
import { useMenuContext } from '../context/MenuContext';

export const ProductRecipeTab = () => {
  const { bomItems, setBomItems, inventoryItems } = useMenuContext();

  const handleAddBomItemRow = () => setBomItems([...bomItems, { inventory_item_id: "", quantity: 1, unit: "" }]);
  
  const handleRemoveBomItemRow = (index) => {
    const newBom = [...bomItems];
    newBom.splice(index, 1);
    setBomItems(newBom);
  };
  
  const handleBomItemChange = (index, field, value) => {
    const newBom = [...bomItems];
    if (field === 'inventory_item_id') {
      const invItem = inventoryItems.find(i => String(i.id) === String(value));
      newBom[index].inventory_item_id = value;
      newBom[index].unit = invItem ? invItem.unit : "";
    } else {
      newBom[index][field] = value;
    }
    setBomItems(newBom);
  };
  return (
    <div className="py-2">
      <p className="text-muted mb-3">Set up the Bill of Materials (BOM) for this product. These ingredients will be deducted from inventory when this product is ordered.</p>
      
      <Table size="sm" bordered hover className="m-0 align-middle shadow-sm bg-white">
        <thead className="bg-light">
          <tr>
            <th className="px-3" style={{ width: "50%" }}>Inventory Item</th>
            <th className="text-center" style={{ width: "20%" }}>Quantity</th>
            <th className="text-center" style={{ width: "15%" }}>Unit</th>
            <th className="text-center" style={{ width: "15%" }}>Remove</th>
          </tr>
        </thead>
        <tbody>
          {(!bomItems || bomItems.length === 0) ? (
            <tr><td colSpan={4} className="text-center py-4 text-muted">No recipe items yet.</td></tr>
          ) : bomItems.map((item, index) => (
            <tr key={index}>
              <td className="px-3">
                <Form.Select 
                  size="sm" 
                  value={item.inventory_item_id} 
                  onChange={(e) => handleBomItemChange(index, 'inventory_item_id', e.target.value)}
                >
                  <option value="">-- Select Item --</option>
                  {inventoryItems.map(inv => (
                    <option key={inv.id} value={inv.id}>{inv.name}</option>
                  ))}
                </Form.Select>
              </td>
              <td className="text-center">
                <Form.Control 
                  type="number" 
                  step="0.01" 
                  min="0.01" 
                  size="sm" 
                  value={item.quantity} 
                  onChange={(e) => handleBomItemChange(index, 'quantity', e.target.value)}
                />
              </td>
              <td className="text-center text-muted small">
                {item.unit || "-"}
              </td>
              <td className="text-center">
                <Button variant="outline-danger" size="sm" onClick={() => handleRemoveBomItemRow(index)}>
                  <FaTrash />
                </Button>
              </td>
            </tr>
          ))}
          <tr className="bg-light">
            <td colSpan={4} className="px-3 py-2">
              <Button variant="outline-primary" size="sm" onClick={handleAddBomItemRow}>
                <FaPlus className="me-1" /> Add Ingredient
              </Button>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};
